import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import {
  Component,
  Input,
  OnDestroy,
  OnInit,
  ChangeDetectionStrategy
} from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { NavigationEnd, Router } from '@angular/router';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { InteractionStatus } from '@azure/msal-browser';
import {
  Observable,
  map,
  shareReplay,
  filter,
  withLatestFrom,
  takeUntil,
  Subject
} from 'rxjs';
import { environment } from '@environments/environment';
import { AppService } from '../../shared/services/app.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class HeaderComponent implements OnInit, OnDestroy {
  @Input() sidenav!: MatSidenav;

  private readonly _destroying$ = new Subject<void>();

  accountName: string | undefined = '';
  headerEnvironmentInfo: string | undefined = '';

  isOnline$ = this.appService.onlineStatus$;

  constructor(
    private breakpointObserver: BreakpointObserver,
    private router: Router,
    private msalBroadcastService: MsalBroadcastService,
    private authService: MsalService,
    private appService: AppService
  ) {}

  isHandset$: Observable<boolean> = this.breakpointObserver
    .observe(Breakpoints.Handset)
    .pipe(
      map((result) => result.matches),
      shareReplay()
    );

  ngOnInit(): void {
    this.headerEnvironmentInfo = environment.headerEnvironmentInfo;
    this.router.events
      .pipe(
        withLatestFrom(this.isHandset$),
        filter(([a, b]) => b && a instanceof NavigationEnd)
      )
      .subscribe(() => this.sidenav.close());

    this.msalBroadcastService.inProgress$
      .pipe(
        filter(
          (status: InteractionStatus) => status === InteractionStatus.None
        ),
        takeUntil(this._destroying$)
      )
      .subscribe(() => {
        this.setLoginDisplay();
      });
  }

  setLoginDisplay() {
    const activeAccount = this.authService.instance.getActiveAccount();
    if (activeAccount) {
      this.accountName = activeAccount.name;
    }
  }

  logout(): void {
    this.authService.logoutRedirect();
  }

  ngOnDestroy() {
    this._destroying$.next();
    this._destroying$.complete();
  }
}
